/** Clamps the teacher-entered reviewer count to the backend's 1–10 range (#167). */
export const MIN_PEER_REVIEWS = 1;
export const MAX_PEER_REVIEWS = 10;

export function clampMinPeerReviews(value: number): number {
    if (Number.isNaN(value)) {
        return MIN_PEER_REVIEWS;
    }
    return Math.min(MAX_PEER_REVIEWS, Math.max(MIN_PEER_REVIEWS, value));
}
